import React from "react";
import {
  Checkbox,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  makeStyles,
  Tooltip,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  active: {
    background: "aliceblue",
  },
  checkboxColor: {
    color: theme.palette.primary.main,
  },
  availablevehiclescolor: {
    color: theme.palette.primary.main,
  },  
}));

export default function VehicleCheckboxList(props) {
  const { vehicleList, vehicles, handleSelectVehicle } = props;
  const classes = useStyles();
  return (
    <List>
      {vehicleList?.map((item) => {
        if (!item.inactive) {
          const isSelected = vehicles?.some((v) => v.id === item.id);
          const vehicleLicencePlate = item?.licensePlate?.number
          const isVehicleIncomplete = item?.complete === false

          return (
              <ListItem
                key={`vehicle-${item?.id}`}
                divider
                className={`${isSelected ? classes.active : ""}`}
                spacing
                disabled={isVehicleIncomplete}
              >
                <Tooltip title={isVehicleIncomplete ? `Vehicle (${vehicleLicencePlate}) is incomplete and cannot be used in new orders` : ``}>
                  <div>
                    <ListItemSecondaryAction className={classes.checkboxColor}>
                    <Checkbox
                      defaultChecked={isSelected}
                      onClick={(e) => handleSelectVehicle(e, item)}
                      color="primary"
                      id={`vehicle-${item?.id}`}
                      disabled={isVehicleIncomplete}
                      aria-label={isVehicleIncomplete ? `Vehicle (${vehicleLicencePlate}) is incomplete and cannot be used in new orders` : `Select vehicle (${vehicleLicencePlate})`}
                    />
                    </ListItemSecondaryAction>
                    <ListItemText>
                      <label htmlFor={`vehicle-${item?.id}`} className={classes.availablevehiclescolor}>
                        <b>
                        {`${item?.year || ""} ${item?.color || ""} ${
                          item?.make?.name || ""
                        } ${item?.model || ""}`}
                        </b>

                        <p>
                        {item.licensePlate?.state?.code} - {vehicleLicencePlate}{" "}
                        VIN : {item?.vin || "N/A"}
                        </p>
                      </label>
                    </ListItemText>
                  </div>
                </Tooltip>
              </ListItem>
          );
        }
        return null;
      })}
    </List>
  );
};